import React from "react";

const ValidationMessage = ({ message }) => {
  return <div className="text-error errors">{message}</div>;
};
export default ValidationMessage;
